<tec-tile [title]="'PROCESSES.DETAIL.JSON' | translate" icon="icon-back-ajax-result">
    <ng-container actions>
        <tec-menu [options]="workflowsHelper.detailJsonMenuOpt" (valueChange)="onDataJsonMenuChange($event)">
            <tec-button-icon [icon]="'icon-more'" />
        </tec-menu>
    </ng-container>

    <ngx-json-viewer [json]="detail" />
</tec-tile>
